var map = {
	"./SOBA_102 (1).jpg": 2045,
	"./SOBA_102 (4).jpg": 9070,
	"./SOBA_102 (7).jpg": 355,
	"./SOBA_203 (1).jpg": 2283,
	"./SOBA_203 (2).jpg": 9222,
	"./SOBA_203 (3).jpg": 7041,
	"./SOBA_203 (4).jpg": 9484,
	"./SOBA_203 (5).jpg": 9535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8518;